export const REDUCER_NAME = 'email'

export const DEFAULT_DESIGN_TEMPLATE = '288'

export const DESIGN_TEMPLATE_LIST = [
    {
        id: '288',
        value: 'default',
    },
    {
        id: '315',
        value: 'delivery',
    },
    {
        id: '303',
        value: 'no_good_news',
    },
    {
        id: '343',
        value: 'quotation',
    },
    {
        id: '318',
        value: 'imprint_reminder',
    },
    {
        id: '317',
        value: 'image_reminder',
    },
    {
        id: '316',
        value: 'Payment',
    },
    {
        id: '282',
        value: 'Payment_fwf',
    },
    {
        id: '319',
        value: 'imprint_reminder_fwf',
    },
    {
        id: '320',
        value: 'image_reminder_fwf',
    },
    {
        id: '287',
        value: 'UK_Payment_fwf',
    },
    {
        id: '307',
        value: 'UK_default',
    },
    {
        id: '286',
        value: 'ESP_Payment',
    },
    {
        id: '305',
        value: 'ESP_Medical',
    },
    {
        id: '308',
        value: 'CH_Payment',
    },
    {
        id: '326',
        value: 'CH_Medical',
    },
    {
        id: '338',
        value: 'CH_Medical_Plain',
    },
    {
        id: '324',
        value: 'AT_Payment',
    },
    {
        id: '309',
        value: 'AT_Medical',
    },
    {
        id: '283',
        value: 'FR_Payment',
    },
    {
        id: '298',
        value: 'FR_Medical',
    },
    {
        id: '329',
        value: 'AT_Medical_Plain',
    },
    {
        id: '284',
        value: 'NL_Payment',
    },
    {
        id: '299',
        value: 'NL_Medical',
    },
    {
        id: '285',
        value: 'SE_Medical',
    },
    {
        id: '301',
        value: 'SE_Payment',
    },
    {
        id: '328',
        value: 'Insurance_first_alignerCheckin',
    },
    {
        id: '327',
        value: 'How_to_take_Images',
    },
    {
        id: '331',
        value: 'AT_How_to_take_Images',
    },
    {
        id: '335',
        value: 'CH_How_to_take_Images',
    },
    {
        id: '333',
        value: 'Benefits_of_the_app_DE',
    },
    {
        id: '330',
        value: 'Benefits_of_the_app_AT',
    },
    {
        id: '337',
        value: 'Benefits_of_the_app_CH',
    },
    {
        id: '278',
        value: 'BE_Payment',
    },
    {
        id: '281',
        value: 'BE_Payment_French',
    },
    {
        id: '273',
        value: 'BE_Medical',
    },
    {
        id: '322',
        value: 'BE_Medical_French',
    },
    {
        id: '277',
        value: 'BE_4days',
    },
    {
        id: '300',
        value: 'IT_Payment',
    },
    {
        id: '289',
        value: 'IT_Medical',
    },
    {
        id: '306',
        value: 'IT_4days',
    },
    {
        id: '272',
        value: 'DK_Payment',
    },
    {
        id: '274',
        value: 'DK_Medical',
    },
    {
        id: '275',
        value: 'DK_4days',
    },
]

export const BRAND_LIST = [
    {
        id: 'sunshine',
        value: 'Sunshine',
    },
    {
        id: 'dentale',
        value: 'Dentale',
    },
]



// WEBPACK FOOTER //
// ./src/modules/email/state/manage/const.js